/**
 * Wraps analytics in a dynamic import so `analytics.js` is not part of the main
 * chunk (saves ~1–2 KB gzip + removes it from Lighthouse "unused JS" for
 * routes that never fire events). Events are queued until the module loads.
 */
let impl = null;
let loading = null;
const queue = [];

function flush() {
  if (!impl) return;
  while (queue.length) {
    const { name, args } = queue.shift();
    const fn = impl[name];
    if (typeof fn === 'function') fn.apply(impl, args);
  }
}

function ensure() {
  if (impl) return;
  if (!loading) {
    loading = import('./analytics')
      .then((m) => {
        impl = m.track;
        flush();
      })
      .catch(() => {
        loading = null;
      });
  }
}

function call(name, args) {
  if (impl && impl[name]) {
    impl[name](...args);
    return;
  }
  queue.push({ name, args });
  ensure();
}

export const track = new Proxy(
  {},
  {
    get(_, prop) {
      if (typeof prop !== 'string') return undefined;
      return (...args) => call(prop, args);
    },
  }
);
